import React from 'react';

function ApplicationBilling(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-468.000000, -190.000000)">
          <g transform="translate(416.000000, 146.000000)">
            <g transform="translate(52.000000, 44.000000)" fill="#FFFFFF">
              <rect opacity="0.200000003" x="2" y="6" width="22" height="14" rx="1" />
              <path d="M22,5 C22.5522847,5 23,5.44771525 23,6 L23,18 C23,18.5522847 22.5522847,19 22,19 L2,19 C1.44771525,19 1,18.5522847 1,18 L1,6 C1,5.44771525 1.44771525,5 2,5 L22,5 Z M5.5,16 L3.5,16 C3.22385763,16 3,16.2238576 3,16.5 C3,16.7761424 3.22385763,17 3.5,17 L3.5,17 L5.5,17 C5.77614237,17 6,16.7761424 6,16.5 C6,16.2238576 5.77614237,16 5.5,16 L5.5,16 Z M12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 Z M20.5,7 L18.5,7 C18.2238576,7 18,7.22385763 18,7.5 C18,7.77614237 18.2238576,8 18.5,8 L18.5,8 L20.5,8 C20.7761424,8 21,7.77614237 21,7.5 C21,7.22385763 20.7761424,7 20.5,7 L20.5,7 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ApplicationBilling;
